
if (typeof Function.prototype.bind === 'undefined') {
  Function.prototype.bind = function (context) {
    var params = ([]).slice.call(arguments, 1);
    var fn = this;
    return function () {
      var allParams = params.concat(([]).slice.call(arguments, 0));
      return fn.apply(context, allParams);
    };
  };
};
module.exports = function anonymous(locals, escape, include, rethrow
/*``*/) {
escape = escape || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<!-- tips弹层 可完全自定义 -->\n<div class=\"js_weixin_share_tips wxtips\" >\n    <div class=\"ts_wx\" style=\"\">\n        <div style=\"position:relative; padding:10px 9px 7px;z-index: 1000;height: 100%; width: 100%;\">\n            <img src=\"")
    ; __append(escape(qrcode_url))
    ; __append("\" style=\"width:90px; height:90px;\" />\n        </div>\n    </div>\n</div>")
  }
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.share.pc/app/tips.ejs
// module id = 326
// module chunks = 0